import {
  Accordion, AccordionDetails, AccordionSummary, Box, Button, Card, CardActions, CardContent,
  Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, List, ListItem,
  ListItemText, Stack, TableCell, TableRow, Typography
} from "@mui/material";
import { Dispatch, FC, SyntheticEvent, useState } from "react";
import { cellStyle } from "../Pays/RowPays";
import { btnStyle } from "../user/Tabs/utilisateur/UtilisateurRow";
import DeleteIcon from "@mui/icons-material/Delete";
import TarifForms from "../../../forms/Tarif/TarifForms";
import { IPays } from "../Pays/Pays";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { LoadingButton } from "@mui/lab";
import { AxiosInstance } from "axios";
import UserInformation from "../../../../types/UserInformation";
import { Reducers } from "../../../../redux/reducers";
import { useSelector } from "react-redux";
import { managerIdConstanteNumber } from "../../../../constants/Constants";
import { TarifInterface } from "./InterfaceTarification";
import OptionalWidthModal from "../../../../commons/optional-width-modal/OptionalWidthModal";
import DuplicateTarifForm from "../../../forms/Tarif/DuplicateTarifForm";
import { IPeriodeCloture } from "../../production/SaisieAgent";
import CheckAttr from "../../../../utils/CheckAttr";

interface TarificationRowAtribute {
  isDesktopOrLaptop: boolean;
  http: AxiosInstance;
  row: TarifInterface;
  dataRefPaysBu: IPays[];
  reloadList: () => void;
  expanded: number | false;
  setExpanded: Dispatch<React.SetStateAction<number | false>>;
  allPeriodeClotured: IPeriodeCloture[]
}

const TarificationRow: FC<TarificationRowAtribute> = ({
  isDesktopOrLaptop,
  row,
  http,
  dataRefPaysBu,
  reloadList,
  expanded,
  setExpanded,
  allPeriodeClotured
}) => {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [openModalDelete, setOpenModalDelete] = useState<boolean>(false);
  const [openModalDup, setOpenModalDup] = useState<boolean>(false);
  const [deleteLoading, setDeleteLoading] = useState<boolean>(false);
  const logger = useSelector<Reducers>(
    (state) => state.logger
  ) as UserInformation;

  const handleDelete = () => {
    setDeleteLoading(true);
    http.get(`tarification/delete/${row.id}`)
      .then(() => {
        setOpenModalDelete(false);
        reloadList();
      }).catch(error => {
        console.log(error);
      }).finally(() => {
        setDeleteLoading(false);
      });
  };

  const handleClose = () => {
    setOpenModal(false);
  };

  const handleCloseDup = () => {
    setOpenModalDup(false);
  };

  const handleChangeAccordionValue = (panel: number) => (event: SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };

  const disabledBtn = (): boolean => {
    if (CheckAttr(row.date_fin) || row?.article?.actif === 0) {
      return true;
    }

    return false;
  };

  let decimalPrecision = 2;
  if (row?.article?.devise?.code_iso === 'TND') {
    decimalPrecision = 3;
  }

  return (
    <>
      {isDesktopOrLaptop ? (
        <TableRow>
          <TableCell style={cellStyle} align="center">
            {row?.article?.pivot_pays_bu?.pays?.libelle}
          </TableCell>
          <TableCell style={cellStyle} align="center">
            {row?.article?.pivot_pays_bu?.business_unit?.libelle}
          </TableCell>
          <TableCell style={cellStyle} align="center">
            {row?.article?.piv_oper_soc_code?.operation?.client?.libelle}
          </TableCell>
          <TableCell style={cellStyle} align="center">
            {row?.article?.piv_oper_soc_code?.operation?.libelle}
          </TableCell>
          <TableCell style={cellStyle} align="center">
            {row?.article?.piv_oper_soc_code?.piv_societe_fact_code?.societe_facturation?.libelle}{" "}
          </TableCell>
          <TableCell style={cellStyle} align="center">
            {row?.article?.piv_oper_soc_code?.piv_societe_fact_code?.code_gesco?.libelle}{" "}
          </TableCell>

          <TableCell style={cellStyle} align="center">
            {row?.article?.code_article?.libelle}
          </TableCell>

          <TableCell style={cellStyle} align="center">
            {row?.article?.libelle}{" "}
          </TableCell>
          <TableCell style={cellStyle} align="center">
            {row.date_debut.toString()}
          </TableCell>
          <TableCell style={cellStyle} align="center">
            {row.date_fin?.toString()}
          </TableCell>
          <TableCell style={cellStyle} align="center">
            {row.tarifheure && Number(row.tarifheure).toFixed(decimalPrecision)}
          </TableCell>
          <TableCell style={cellStyle} align="center">
            {row.tarifacte && Number(row.tarifacte).toFixed(decimalPrecision)}
          </TableCell>
          {logger?.profils?.id != managerIdConstanteNumber && (
            <TableCell style={cellStyle} align="center">
              <Stack direction="row" spacing={1}>
                <Button
                  size="small"
                  variant="outlined"
                  startIcon={<BorderColorIcon />}
                  onClick={() => setOpenModal(true)}
                  sx={btnStyle({
                    bgColor: "#070d23",
                    hoverColor: "Gray",
                    color: "#fff",
                  })}
                  disabled={disabledBtn()}
                >
                  Modifier
                </Button>

                {row?.parent_id && (
                  <Button
                    size="small"
                    variant="outlined"
                    sx={btnStyle({
                      bgColor: "#FF0000",
                      hoverColor: "#FE3737",
                    })}
                    startIcon={<DeleteIcon />}
                    onClick={() => setOpenModalDelete(true)}
                    disabled={disabledBtn()}
                  >
                    Supprimer
                  </Button>
                )}

                <Button
                  size="small"
                  variant="contained"
                  color="warning"
                  startIcon={<ContentCopyIcon />}
                  sx={{ textTransform: 'none' }}
                  onClick={() => setOpenModalDup(true)}
                  disabled={disabledBtn()}
                >
                  Dupliquer
                </Button>
              </Stack>
            </TableCell>
          )}
        </TableRow>
      ) : (
        <Accordion
          expanded={expanded === row?.id}
          onChange={handleChangeAccordionValue(row?.id as number)}
          sx={{
            borderRadius: 1,
            bgcolor: '#fff',
            mb: 1,
            ml: 0.1
          }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: '#080d24' }} />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Stack direction="column">
              <List sx={{ py: 0 }} dense>
                <ListItem sx={{ my: 0, py: 0 }} dense>
                  <ListItemText
                    primary="Désignation :"
                    secondary={
                      <Typography sx={{ fontSize: 12, color: '#FC8404' }}>
                        {row?.article?.libelle}
                      </Typography>
                    }
                  />
                </ListItem>
                <ListItem sx={{ my: 0, py: 0 }} dense>
                  <ListItemText
                    primary="Code Article :"
                    secondary={
                      <Typography sx={{ fontSize: 12, color: '#FC8404' }}>
                        {row?.article?.code_article?.libelle}
                      </Typography>
                    }
                  />
                </ListItem>
                <ListItem sx={{ my: 0, py: 0 }} dense>
                  <ListItemText
                    primary="Date début :"
                    secondary={
                      <Typography sx={{ fontSize: 12, color: '#FC8404' }}>
                        {row?.date_debut}
                      </Typography>
                    }
                  />
                </ListItem>
                {row?.date_fin && (
                  <ListItem sx={{ my: 0, py: 0 }} dense>
                    <ListItemText
                      primary="Date fin :"
                      secondary={
                        <Typography sx={{ fontSize: 12, color: '#FC8404' }}>
                          {row?.date_fin}
                        </Typography>
                      }
                    />
                  </ListItem>)}
                {row?.tarifheure && (
                  <ListItem sx={{ my: 0, py: 0 }} dense>
                    <ListItemText
                      primary="Tarif Heure :"
                      secondary={
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: 'bold', color: '#FC8404' }}
                        >
                          {row?.tarifheure}
                        </Typography>
                      }
                    />
                  </ListItem>)}
                {row?.tarifacte && (
                  <ListItem sx={{ my: 0, py: 0 }} dense>
                    <ListItemText
                      primary="Tarif Acte :"
                      secondary={
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: 'bold', color: '#FC8404' }}
                        >
                          {row?.tarifacte}
                        </Typography>
                      }
                    />
                  </ListItem>)}
              </List>
            </Stack>
          </AccordionSummary>
          <AccordionDetails>
            <Stack direction='column' spacing={1}>
              {logger?.profils?.id != managerIdConstanteNumber && (
                <>
                  <Button
                    variant="contained"
                    sx={btnStyle({
                      bgColor: "Gray",
                      hoverColor: "Gray",
                      color: "#fff",
                    })}
                    size='small'
                    fullWidth
                    startIcon={<BorderColorIcon />}
                    onClick={() => setOpenModal(true)}
                    disabled={disabledBtn()}
                  >
                    Modifier
                  </Button >
                  <Button
                    size="small"
                    variant="contained"
                    sx={btnStyle({
                      bgColor: "#FF0000",
                      hoverColor: "#FE3737",
                    })}
                    fullWidth
                    startIcon={<DeleteIcon />}
                    onClick={() => setOpenModalDelete(true)}
                    disabled={disabledBtn()}
                  >
                    Supprimer
                  </Button>
                </>
              )}

              <Box>
                <Typography gutterBottom variant="h5" component="div" sx={{ mb: 0, mt: 2 }}>
                  Détails
                </Typography>
                <Divider orientation="horizontal" sx={{ bgcolor: "#fff", mb: 1 }} />
              </Box>

              <Card>
                <CardContent>
                  <List dense>
                    <ListItem dense>
                      <ListItemText
                        primary="Pays :"
                        secondary={row?.article?.pivot_pays_bu?.pays?.libelle}
                      />
                    </ListItem>
                    <Divider orientation="horizontal" sx={{ bgcolor: " #dfdfdf" }} />
                    <ListItem dense>
                      <ListItemText
                        primary="Bu :"
                        secondary={row?.article?.pivot_pays_bu?.business_unit?.libelle}
                      />
                    </ListItem>
                    <Divider orientation="horizontal" sx={{ bgcolor: " #dfdfdf" }} />
                    <ListItem dense>
                      <ListItemText
                        primary="Client :"
                        secondary={row?.article?.piv_oper_soc_code?.operation?.client?.libelle}
                      />
                    </ListItem>
                    <Divider orientation="horizontal" sx={{ bgcolor: " #dfdfdf" }} />
                    <ListItem dense>
                      <ListItemText
                        primary="Opération :"
                        secondary={row?.article?.piv_oper_soc_code?.operation?.libelle}
                      />
                    </ListItem>
                    <Divider orientation="horizontal" sx={{ bgcolor: " #dfdfdf" }} />
                    <ListItem dense>
                      <ListItemText
                        primary="Code Gesco :"
                        secondary={row?.article?.piv_oper_soc_code?.piv_societe_fact_code?.code_gesco?.libelle}
                      />
                    </ListItem>
                    <Divider orientation="horizontal" sx={{ bgcolor: " #dfdfdf" }} />
                    <ListItem dense>
                      <ListItemText
                        primary="Société facturation :"
                        secondary={row?.article?.piv_oper_soc_code?.piv_societe_fact_code?.societe_facturation?.libelle}
                      />
                    </ListItem>
                  </List>
                </CardContent>
                <CardActions>
                  <Button
                    size="small"
                    startIcon={<ContentCopyIcon />}
                    color="warning"
                    onClick={() => setOpenModalDup(true)}
                    sx={{ textTransform: "none" }}
                  >
                    Dupliquer
                  </Button>
                </CardActions>
              </Card>
            </Stack>
          </AccordionDetails>
        </Accordion>
      )}

      <OptionalWidthModal
        title="Modifier un tarif"
        breackPoint="md"
        onClose={handleClose}
        open={openModal}
      >
        <TarifForms
          http={http}
          reloadList={reloadList}
          rowtarifToUpdate={row}
          dataRefPaysBu={dataRefPaysBu}
          onClose={handleClose}
          allPeriodeClotured={allPeriodeClotured}
        />
      </OptionalWidthModal>

      <OptionalWidthModal
        title="Dupliquer un tarif"
        breackPoint="md"
        onClose={handleCloseDup}
        open={openModalDup}
      >
        <DuplicateTarifForm
          http={http}
          rowtarifToUpdate={row}
          reloadList={reloadList}
          onClose={handleCloseDup}
          allPeriodeClotured={allPeriodeClotured}
        />
      </OptionalWidthModal>

      <Dialog
        open={openModalDelete}
        keepMounted
        onClose={(e) => setOpenModalDelete(false)}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"Confirmation"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Vous êtes sur le point de supprimer ce Tarif, êtes-vous sûr de
            vouloir poursuivre cette action ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <LoadingButton
            onClick={() => handleDelete()}
            endIcon={<DeleteIcon />}
            loading={deleteLoading}
            loadingPosition="end"
            sx={{ textTransform: "none" }}
            variant="contained"
            color="warning"
          >
            Oui
          </LoadingButton>
          <Button
            onClick={(e) => setOpenModalDelete(false)}
            variant="contained"
            color="inherit"
            sx={{ textTransform: "none" }}
            startIcon={<ExitToAppIcon />}
          >
            Non
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default TarificationRow;
